import { StateMachine } from "common/libs/dialog-handler";
import textParser from "common/libs/textParser";
import _ from "underscore";
import moment from "moment";
import {
  isFAQShown,
  isFeedBacked
} from "common/libs/ticketHandler";

export const STEP_STATUS = {
  INIT: "init",
  SCRIPT_NOT_FOUND: "script_not_found",
  SEARCH_FAILED: "search_failed",
  LAST_STEP: "last_step",
  IN_SCENARIO: "in_scenario",
  FEEDBACK: "feedback",
  READY_CONNECT: "ready_connect",
  INTERRUPTION: "interruption"
};

const TICKET_STATUS = {
  OPEN: "open",
  SCRIPT_NOT_FOUND: "scriptNotFound",
  SEARCH_FAILED: "searchFailed",
  RESEARCH: "re-search",
  ANSWERED: "answered",
  QUIT: "quit",
  RESOLVED: "resolved",
  UNRESOLVED: "unresolved"
};

const FEEDBACK_STATUS = {
  RESOLVED: "resolved",
  UNRESOLVED: "unresolved"
};

class BotActions {
  constructor({ commit, rootState, state, dispatch }, keyName) {
    this.commit = commit;
    this.rootState = rootState;
    this.state = state;
    this.dispatch = dispatch;
    this.keyName = keyName;
  }

  setNewState(stateParams) {
    this.commit("setStepId", { stepId: stateParams.stepId });
    this.commit("setStepStatus", { stepStatus: stateParams.stepStatus });
  }

  doStateTransition() {}

  doActionMutation() {}

  _createMessage() {}

  _createTicket(type) {}

  async _postTicket(ticket) {
    await this.dispatch("postTicket", ticket);
  }
  _updateTicketItems(items) {
    this.dispatch("updateTicketItems", items);
  }
  _deleteTicketKeys(items) {
    this.dispatch("deleteTicketKeys", items);
  }
  _addMessage(message) {
    this.commit("addMessage", message);
  }
  _goBackToInit() {
    this.dispatch("addInitMessage");
  }
  _goToNextAction() {
    this.dispatch("dispatchAction");
  }
}

class AddInitMessage extends BotActions {
  doStateTransition() {
    const stateParams = {
      stepId: "init",
      stepStatus: STEP_STATUS.INIT,
      transitionType: "success"
    };
    return stateParams;
  }
  doActionMutation(newState) {
    const message = this._createMessage(newState.transitionType);
    this._addMessage(message);
    this.commit("clearStepIdHistory")
  }
  _createMessage(type) {
    let messageContent;
    if (this.rootState.category && this.rootState.resources) {
      messageContent = {
        text: this.rootState.constObj.INIT_MESSAGE,
        choices: this.rootState.category
      };
    } else {
      messageContent = {
        text: this.rootState.constObj.NOT_FOUND_PACKAGE,
        choices: []
      };
    }
    return { from: "bot", content: messageContent };
  }
}

class AddUserMessage extends BotActions {
  setUserMessage(text) {
    this.userMessage = text;
  }
  doActionMutation(type) {
    const message = this._createMessage(type);
    this._addMessage(message);
  }
  _createMessage(type) {
    const text = this.userMessage;
    const messageContent = { text };
    return {
      from: "user",
      status: this.state.stepStatus,
      content: messageContent
    };
  }
}

class AddSearchResultMessage extends BotActions {
  setSearchResult(searchResult) {
    this.searchResult = searchResult;
  }
  doStateTransition() {
    const isNotFound = this.searchResult.length <= 0;
    let stateParams;
    if (isNotFound) {
      stateParams = {
        stepId: "init",
        stepStatus: STEP_STATUS.SCRIPT_NOT_FOUND,
        transitionType: "error"
      };
    } else {
      stateParams = {
        stepId: "init",
        stepStatus: STEP_STATUS.INIT,
        transitionType: "success"
      };
    }
    return stateParams;
  }
  doActionMutation(type) {
    const ticket = this._createTicket(type);
    if (ticket) {
      this._postTicket(ticket);
    }
    if (ticket.status === TICKET_STATUS.SCRIPT_NOT_FOUND && this.rootState.constObj.HAS_UNRESOLVED_ENQUETE) {
      return;
    }
    const message = this._createMessage(type);
    this._addMessage(message);
  }
  _createMessage(type) {
    let messageContent;
    if (type === "success") {
      const choices = {};
      this.searchResult
        .filter(e => e.items.scenario_id)
        .forEach(e => {
          choices[e.items.scenario_id] = e.text;
        });
      Object.assign(choices, {
        other_choice: this.rootState.constObj.OTHER_CHOICE
      });
      messageContent = {
        text: this.rootState.constObj.CHOICES_TITLE,
        choices: choices
      };
    } else {
      messageContent = {
        text: this.rootState.constObj.SCRIPT_NOT_FOUND_MESSAGE
      };
    }
    return { from: "bot", content: messageContent };
  }
  _createTicket(type) {
    let ticketContent;
    if (type === "success") {
      ticketContent = {
        status: TICKET_STATUS.OPEN,
        mode: "bot"
      };
    } else {
      ticketContent = {
        status: TICKET_STATUS.SCRIPT_NOT_FOUND,
        mode: "bot"
      };
      if (this.rootState.constObj.HAS_UNRESOLVED_ENQUETE) {
        this.dispatch("openEnquete", "bot");
      }
    }
    return ticketContent;
  }
}

class AddBotMessage extends BotActions {
  async doStateTransition(keyName) {
    let stateParams;
    if (keyName === "other_choice") {
      await 0
      stateParams = {
        stepId: this.state.stepId,
        stepStatus: this.rootState.constObj.HAS_OPERATOR
          ? STEP_STATUS.READY_CONNECT
          : STEP_STATUS.INIT,
        transitionType: "error"
      };
    } else {
      const options = { customFunctions: {} };
      const stateMachine = new StateMachine(this.rootState.resources, options);
      stateMachine.setStepIdById(this.state.stepId);
      this.newState = await stateMachine.proceed(keyName, {});

      const refId = textParser.extractRefId(this.newState.data.text);
      // 回答に{ref_id=xxxx}が含まれている場合、参照先のFAQを取得する
      if (refId && this.rootState.resources.scenario.step[refId]) {
        const refFaq = stateMachine.getStepById(refId).actions.success;
        refFaq.text = refFaq.value;
        this.newState = {state: "success", stepId: refId, data: refFaq}
      }
      const hasNextStep = stateMachine.isLastStep(this.newState);

      stateParams = {
        stepId: this.newState.stepId,
        stepStatus: hasNextStep
          ? STEP_STATUS.IN_SCENARIO
          : STEP_STATUS.LAST_STEP,
        transitionType: "success"
      };
    }
    return stateParams;
  }

  _createMessage(type) {
    if (type === "success") {
      return {
        from: "bot",
        content: textParser.parseButton(this.newState.data.text),
        status: this.state.stepStatus
      };
    }

    if (this.state.stepStatus === STEP_STATUS.READY_CONNECT) {
      return {
        from: "bot",
        content: {
          text: this.rootState.constObj.OTHER_CHOICE_MESSAGE,
          choices: this.rootState.constObj.CONNECT_OPERATOR_CHOICES
        },
        status: this.state.stepStatus
      };
    } else {
      return {
        from: "bot",
        content: { text: this.rootState.constObj.OTHER_CHOICE_MESSAGE },
        status: this.state.stepStatus
      };
    }
  }

  doActionMutation(type) {
    const ticket = this._createTicket(type);
    if (ticket) {
      this._postTicket(ticket);
    }
    if ((ticket.status !== TICKET_STATUS.SEARCH_FAILED) || (ticket.status === TICKET_STATUS.SEARCH_FAILED && !this.rootState.constObj.HAS_UNRESOLVED_ENQUETE)) {
      const message = this._createMessage(type);
      this._addMessage(message);
    }
    if (this.state.stepStatus === STEP_STATUS.LAST_STEP && type === "success") {
      this._goToNextAction();
    }
  }

  _createTicket(type) {
    let ticketContent;
    if (type === "success") {
      ticketContent = {
        status:
          this.state.stepStatus === STEP_STATUS.LAST_STEP
            ? TICKET_STATUS.ANSWERED
            : TICKET_STATUS.OPEN,
        mode: "bot"
      };
      this._updateTicketItems(this.newState.data.items);
    } else {
      ticketContent = {
        status: TICKET_STATUS.SEARCH_FAILED,
        mode: "bot"
      };
      if (this.rootState.constObj.HAS_UNRESOLVED_ENQUETE) {
        this.dispatch("openEnquete", "bot");
      }
    }

    return ticketContent;
  }
}

class BackBotMessage extends BotActions {
  async doStateTransition(keyName) {
    let stateParams;
    if (keyName === "other_choice") {
      stateParams = {
        stepId: this.state.stepId,
        stepStatus: this.rootState.constObj.HAS_OPERATOR
          ? STEP_STATUS.READY_CONNECT
          : STEP_STATUS.INIT,
        transitionType: "error"
      };
    } else {
      const options = { customFunctions: {} };
      const stateMachine = new StateMachine(this.rootState.resources, options);
      stateMachine.setStepIdById(this.state.stepId);
      this.newState = await stateMachine.proceed(keyName, {});
      const hasNextStep = stateMachine.isLastStep(this.newState);

      stateParams = {
        stepId: this.newState.stepId,
        stepStatus: hasNextStep
          ? STEP_STATUS.IN_SCENARIO
          : STEP_STATUS.LAST_STEP,
        transitionType: "success"
      };
    }
    return stateParams;
  }

  _createMessage(type) {
    if (type === "success") {
      return {
        from: "bot",
        content: textParser.parseButton(this.newState.data.text),
        status: this.state.stepStatus
      };
    }

    if (this.state.stepStatus === STEP_STATUS.READY_CONNECT) {
      return {
        from: "bot",
        content: {
          text: this.rootState.constObj.OTHER_CHOICE_MESSAGE,
          choices: this.rootState.constObj.CONNECT_OPERATOR_CHOICES
        },
        status: this.state.stepStatus
      };
    } else {
      return {
        from: "bot",
        content: { text: this.rootState.constObj.OTHER_CHOICE_MESSAGE },
        status: this.state.stepStatus
      };
    }
  }

  doActionMutation(type) {
    const ticket = this._createTicket(type);
    if (ticket) {
      this._postTicket(ticket);
    }

    if ((ticket.status !== TICKET_STATUS.SEARCH_FAILED) || (ticket.status === TICKET_STATUS.SEARCH_FAILED && !this.rootState.constObj.HAS_UNRESOLVED_ENQUETE)) {
      const message = this._createMessage(type);
      this._addMessage(message);
    }
    if (this.state.stepStatus === STEP_STATUS.LAST_STEP && type === "success") {
      this._goToNextAction();
    }
  }

  _createTicket(type) {
    let ticketContent;
    if (type == 'success') {
      ticketContent = {
        status:
          this.state.stepStatus === STEP_STATUS.LAST_STEP
            ? TICKET_STATUS.ANSWERED
            : TICKET_STATUS.OPEN,
        mode: "bot"
      };
      this.dispatch("updateTicketItemsForBackStep", {
        addParams: this._getUpdateParams(),
        deleteKeys: this._getDeleteKeys()
      });
    } else {
      ticketContent = {
        status: TICKET_STATUS.SEARCH_FAILED,
        mode: "bot"
      };
      if (this.rootState.constObj.HAS_UNRESOLVED_ENQUETE) {
        this.dispatch("openEnquete", "bot");
      }
    }
    return ticketContent;
  }

  _getUpdateParams() {
    const updateParams = {};
    // FAQが既に表示されている場合はticketを新規発行ため、rangeKeyを更新
    if (this.state.isFAQDisplayed) {
      const now = parseInt(moment().utc().format("x"))
      updateParams['rangeKey'] = now;
      updateParams['start_date'] = now;

      if (this.newState.data.items.scenario_id) {
        const scenario = this._findScenarioWithLevel(this.newState.data.items.scenario_id)

        // FAQ(３階層目以降)では常にlog_faq_parent_categoryは3つ、log_faq_child_categoryは2つにする
        // log_faq、log_faq_titleは階層に応じて複製する
        const logFaqParentCategoryCount = 3
        const logFaqChildCategoryCount = 2
        updateParams['log_faq_parent_category'] = scenario.data.items.log_faq_parent_category.flatMap(element => Array(logFaqParentCategoryCount).fill(element)); 
        updateParams['log_faq_child_category'] = scenario.data.items.log_faq_child_category.flatMap(element => Array(logFaqChildCategoryCount).fill(element));
        updateParams['log_faq'] = scenario.data.items.log_faq.flatMap(element => Array(scenario.level).fill(element));
        updateParams['log_faq_title'] = scenario.data.items.log_faq_title.flatMap(element => Array(scenario.level).fill(element));
      }
    }
    return { ...this.newState.data.items, ...updateParams }
  }

  _findScenarioWithLevel(scenarioId) {
    const scenario = this.rootState.resources.scenario;
    function searchInNext(nextArray, currentLevel = 1) {
      if (!Array.isArray(nextArray)) return null;
      
      for (const item of nextArray) {
        // 現在のitemをチェック
        if (item.items && item.items.scenario_id === scenarioId) {
          return {
            data: item,
            level: currentLevel,
          };
        }
        
        // idが一致するかチェック
        if (item.id === scenarioId) {
          return {
            data: item,
            level: currentLevel,
          };
        }
        
        // nextが存在する場合は再帰的に検索（レベルを1つ増加）
        if (item.next && item.next.length > 0) {
          const result = searchInNext(item.next, currentLevel + 1);
          if (result) return result;
        }
      }
      
      return null;
    }
    
    // rootから開始（レベル1）
    if (scenario.flow && scenario.flow.root && scenario.flow.root.next) {
      return searchInNext(scenario.flow.root.next);
    }
    
    return null;
  }

  _getDeleteKeys() {
    const answerType = this._getAnswerType();
    if (answerType === "parent_category") {
      return ["log_faq_child_category", "log_faq", "log_faq_title"];
    } else if (answerType === "child_category") {
      return ["log_faq", "log_faq_title"];
    }
    return [];
  }

  _getAnswerType() {
    const items = this.newState.data.items;

    if (items.log_faq && items.log_faq_title && !items.log_faq_parent_category && !items.log_faq_child_category) {
      return "faq";
    } else if (!items.log_faq && !items.log_faq_title && items.log_faq_parent_category && items.log_faq_child_category) {
      return "child_category";
    } else if (!items.log_faq && !items.log_faq_title && items.log_faq_parent_category && !items.log_faq_child_category) {
      return "parent_category";
    }
  }
}

class AddAskFeedbackMessage extends BotActions {
  doStateTransition() {
    const stateParams = {
      stepId: this.state.stepId,
      stepStatus: STEP_STATUS.FEEDBACK,
      transitionType: "success"
    };
    return stateParams;
  }
  _createMessage(type) {
    const messageContent = {
      text: this.rootState.constObj.ASK_FEEDBACK_MESSAGE,
      choices: this.rootState.constObj.ASK_FEEDBACK_CHOICES
    };
    return {
      from: "bot",
      status: STEP_STATUS.FEEDBACK,
      content: messageContent
    };
  }
  doActionMutation(type) {
    const message = this._createMessage(type);
    this._addMessage(message);
  }
}

class AddFinalMessage extends BotActions {
  doStateTransition() {
    const stateParams = {
      stepId: "init",
      stepStatus: STEP_STATUS.INIT,
      transitionType: "success"
    };
    return stateParams;
  }
  _createMessage(type) {
    const messageContent = { text: this.rootState.constObj.FINAL_MESSAGE };
    return {
      from: "bot",
      status: STEP_STATUS.FEEDBACK,
      content: messageContent
    };
  }
  doActionMutation(type) {
    const message = this._createMessage(type);
    this._addMessage(message);
  }
}

class AddFeedbackDoneMessage extends BotActions {
  doStateTransition() {
    const newStatus =
      this.rootState.constObj.HAS_OPERATOR && this.keyName != "complete"
        ? STEP_STATUS.READY_CONNECT
        : STEP_STATUS.INIT;
    const stateParams = {
      stepId: STEP_STATUS.INIT,
      stepStatus: newStatus,
      transitionType: this.keyName === "complete" ? "success" : "error"
    };

    return stateParams;
  }

  _createMessage(type) {
    if (type === "success") {
      return {
        from: "bot",
        content: { text: this.rootState.constObj.FEEDBACK_DONE_MESSAGE }
      };
    }

    if (this.state.stepStatus === STEP_STATUS.READY_CONNECT) {
      return {
        from: "bot",
        content: {
          // 有人機能ありルート
          // 未解決メッセージをそのまま表示
          text: this.rootState.constObj.FEEDBACK_ERROR_MESSAGE,
          choices: this.rootState.constObj.CONNECT_OPERATOR_CHOICES
        }
      };
    } else {
      this.dispatch("setTicketContents");
      return {
        from: "bot",
        content: { text: this.rootState.constObj.REFLECTED_FEEDBACK_ERROR_MESSAGE }
      };
    }
  }

  _createTicket(type) {
    let ticketContent;
    if (type === "success") {
      ticketContent = {
        status: TICKET_STATUS.ANSWERED,
        feedback: FEEDBACK_STATUS.RESOLVED,
        mode: "bot"
      };
    } else {
      ticketContent = {
        status: TICKET_STATUS.ANSWERED,
        feedback: FEEDBACK_STATUS.UNRESOLVED,
        mode: "bot"
      };
      if (this.rootState.constObj.HAS_UNRESOLVED_ENQUETE) {
        this.dispatch("openEnquete", "bot");
      }
    }
    return ticketContent;
  }

  doActionMutation(type) {
    const ticket = this._createTicket(type);
    if (ticket) {
      this._postTicket(ticket);
    }
    const constObj = this.rootState.constObj
    if (ticket.feedback === FEEDBACK_STATUS.RESOLVED && constObj.HAS_RESOLVED_ENQUETE) {
      return;
    }
    if (ticket.feedback === FEEDBACK_STATUS.UNRESOLVED && constObj.HAS_UNRESOLVED_ENQUETE) {
      return;
    }
    const message = this._createMessage(type);
    this._addMessage(message);
  }
}

class AddInterruptionMessage extends BotActions {
  doStateTransition() {
    const stateParams = {
      stepId: this.state.stepId,
      stepStatus: STEP_STATUS.INTERRUPTION,
      transitionType: "success"
    };
    return stateParams;
  }
  doActionMutation() {
    const lastIndex = _.findLastIndex(this.state.messages, { from: "bot" });
    this.commit("disabledChoices", { index: lastIndex });
    const message = this._createMessage();
    this._addMessage(message);
  }
  _createMessage(type) {
    const messageContent = {
      text: this.rootState.constObj.INTERRUPTION_MESSAGE,
      choices: this.rootState.constObj.INTERRUPTION_CHOICES
    };
    return {
      from: "bot",
      content: messageContent,
      status: STEP_STATUS.INTERRUPTION
    };
  }
}

class AddBackFromInterruptionMessage extends BotActions {
  _getLastMessage() {
    const lastIndex = _.findLastIndex(
      this.rootState.messagesHandler.messages,
      message => {
        return (
          message.from === "bot" && message.status != STEP_STATUS.INTERRUPTION
        );
      }
    );
    const lastContent = this.rootState.messagesHandler.messages[lastIndex];
    return {
      from: "bot",
      content: lastContent.content,
      status: lastContent.status
    };
  }

  doStateTransition() {
    let stateParams;
    if (this.keyName == "ok") {
      stateParams = {
        stepId: "init",
        stepStatus: STEP_STATUS.INIT,
        transitionType: "forward"
      };
    } else {
      this.lastMessage = this._getLastMessage();
      stateParams = {
        stepId: this.state.stepId,
        stepStatus: this.lastMessage.status,
        transitionType: "back"
      };
    }
    return stateParams;
  }

  async doActionMutation(type) {
    if (type === "forward") {
      const ticket = this._createTicket();
      await this._postTicket(ticket);
      await this.dispatch(
        "searchMessage",
        this.rootState.search.searchingMessage
      );
    } else {
      const message = this._createMessage(type);
      this._addMessage(message);
      this.commit("addStepIdHistory", {
        stepId: this.state.stepId
      })
      this._addMessage(this.lastMessage);
      
    }
  }

  _createMessage(type) {
    if (type === "back") {
      const messageContent = {
        text: this.rootState.constObj.BACK_TO_SCENARIO_MESSAGE
      };
      return { from: "bot", content: messageContent };
    }
  }

  _createTicket() {
    const ticketContent = {
      status: TICKET_STATUS.RESEARCH,
      mode: "bot"
    };
    return ticketContent;
  }
}

class AddAskConnectOperator extends BotActions {
  doStateTransition() {
    const stateParams = {
      stepId: "init",
      stepStatus: STEP_STATUS.INIT,
      transitionType: "success"
    };
    return stateParams;
  }

  _createMessage(type) {
    const messageContent = {
      text: this.rootState.constObj.NO_NEED_CONNECT_MESSAGE
    };
    return {
      from: "bot",
      content: messageContent,
      status: STEP_STATUS.LAST_STEP
    };
  }

  doActionMutation(type) {
    const message = this._createMessage(type);
    this._addMessage(message);
  }
}

class AddOperatorFeedbackDoneMessage extends BotActions {
  // このクラスはどこからも呼ばれていない
  doStateTransition() {
    const newStatus =
      this.keyName === "complete"
        ? this.rootState.constObj.FEEDBACK_DONE_MESSAGE
        : this.rootState.constObj.FEEDBACK_ERROR_MESSAGE;
    const stateParams = {
      stepId: "init",
      stepStatus: STEP_STATUS.INIT,
      transitionType: this.keyName === "complete" ? "success" : "error"
    };
    return stateParams;
  }

  _createMessage(type) {
    const messageContent = {
      text:
        this.keyName === "complete"
          ? this.rootState.constObj.FEEDBACK_DONE_MESSAGE
          : this.rootState.constObj.FEEDBACK_ERROR_MESSAGE
    };
    return { from: "bot", content: messageContent };
  }

  _createTicket(type) {
    let ticketContent;
    if (type === "success") {
      ticketContent = {
        status: TICKET_STATUS.RESOLVED,
        mode: "operator"
      };
    } else {
      ticketContent = {
        status: TICKET_STATUS.UNRESOLVED,
        mode: "operator"
      };
    }
    return ticketContent;
  }

  doActionMutation(type) {
    const message = this._createMessage(type);
    this._addMessage(message);
    const ticket = this._createTicket(type);
    if (ticket) {
      this._postTicket(ticket);
    }
    this._goBackToInit();
  }
}

export default {
  state: {
    stepId: "init",
    stepStatus: undefined,
    constObj: undefined,
    isFAQDisplayed: false,
  },

  getters: {
    searchEnabled(state) {
      return !(
        state.stepStatus === STEP_STATUS.LAST_STEP ||
        state.stepStatus === STEP_STATUS.IN_SCENARIO ||
        state.stepStatus === STEP_STATUS.FEEDBACK ||
        state.stepStatus === STEP_STATUS.INTERRUPTION
      );
    }
  },

  mutations: {
    setStepId(state, payload) {
      state.stepId = payload.stepId;
    },
    setStepStatus(state, payload) {
      state.stepStatus = payload.stepStatus;
    },
    setIsFAQDisplayed(state, payload) {
      state.isFAQDisplayed = payload.value;
    },
  },

  actions: {
    async dispatchAction({ commit, rootState, state, dispatch }, keyName) {
      let action;
      let newState;

      const lastIndex = _.findLastIndex(
        rootState.messagesHandler.messages,
        m => m.from != "user"
      );

      if (!rootState.constObj.ENABLE_BACK_STEP 
        || (rootState.messagesHandler.messages[lastIndex]?.status === STEP_STATUS.FEEDBACK || rootState.messagesHandler.messages[lastIndex]?.status === STEP_STATUS.INTERRUPTION)) {
        // 前の階層に戻る機能がない場合は、常に再選択できない
        // 前の階層に戻る機能がある場合は、「解決した/しなかった」だけ再選択できないようにする
        commit("disabledChoices", { index: lastIndex });
      }

      switch (state.stepStatus) {
        case STEP_STATUS.INIT:
        case STEP_STATUS.SCRIPT_NOT_FOUND:
          action = new AddBotMessage(
            { commit, rootState, state, dispatch },
            keyName
          );
          newState = await action.doStateTransition(keyName);
          action.setNewState(newState);
          action.doActionMutation(newState.transitionType);
          break;

        case STEP_STATUS.IN_SCENARIO:
          action = new AddBotMessage(
            { commit, rootState, state, dispatch },
            keyName
          );
          newState = await action.doStateTransition(keyName);
          action.setNewState(newState);
          action.doActionMutation(newState.transitionType);
          break;

        case STEP_STATUS.LAST_STEP:
          if (rootState.constObj.HAS_FEEDBACK) {
            action = new AddAskFeedbackMessage(
              { commit, rootState, state, dispatch },
              null
            );
            newState = action.doStateTransition();
            action.setNewState(newState);
            action.doActionMutation();
          } else {
            action = new AddFinalMessage({
              commit,
              rootState,
              state,
              dispatch
            });
            newState = action.doStateTransition();
            action.setNewState(newState);
            action.doActionMutation(newState.transitionType);
          }
          break;

        case STEP_STATUS.FEEDBACK:
          action = new AddFeedbackDoneMessage(
            { commit, rootState, state, dispatch },
            keyName
          );
          newState = action.doStateTransition();
          action.setNewState(newState);
          action.doActionMutation(newState.transitionType);
          break;

        case STEP_STATUS.INTERRUPTION:
          action = new AddBackFromInterruptionMessage(
            { commit, rootState, state, dispatch },
            keyName
          );
          newState = action.doStateTransition();
          action.setNewState(newState);
          action.doActionMutation(newState.transitionType);
          break;

        case STEP_STATUS.READY_CONNECT:
          action = new AddAskConnectOperator(
            { commit, rootState, state, dispatch },
            keyName
          );
          newState = action.doStateTransition();
          action.setNewState(newState);
          action.doActionMutation(newState.transitionType);
          break;

        default:
          action = new AddInitMessage(
            { commit, rootState, state, dispatch },
            keyName
          );
          newState = action.doStateTransition();
          action.setNewState(newState);
          action.doActionMutation(newState);
      }

      // 前の階層に戻れる機能が使える場合
      if (rootState.constObj.ENABLE_BACK_STEP) {
        if (newState.stepStatus !== STEP_STATUS.FEEDBACK) {
          this.commit("addStepIdHistory", {
            stepId: newState.stepId
          })
        }
        // FAQが表示された & FAQが表示されたフラグがfalse
        if (isFAQShown(rootState.ticket.ticket) && !state.isFAQDisplayed) {
          commit("setIsFAQDisplayed", { value: true });
        }
      }
    },

    async backStep({ commit }, { stepId }) {
      commit("setStepId", { stepId: stepId })
      commit("setStepStatus", { stepStatus: STEP_STATUS.IN_SCENARIO })
    },

    async backStepAction({ commit, rootState, state, dispatch }, { keyName, index }) {
      const lastIndex = _.findLastIndex(
        rootState.messagesHandler.messages,
        m => m.from != "user"
      );

      if (rootState.messagesHandler.messages[lastIndex]?.status === STEP_STATUS.FEEDBACK) {
        commit("disabledChoices", { index: lastIndex });
      }

      const action = new BackBotMessage(
        { commit, rootState, state, dispatch },
        keyName
      );
      const newState = await action.doStateTransition(keyName);
      action.setNewState(newState);
      action.doActionMutation(newState.transitionType);

      commit("addStepIdHistory", {
        stepId: newState.stepId
      })

      // 戻った階層が親カテゴリまたは子カテゴリならfalseにする
      if (!isFAQShown(rootState.ticket.ticket)) {
        commit("setIsFAQDisplayed", { value: false });
      }
    },

    addInitMessage({ commit, rootState, state, dispatch }) {
      const action = new AddInitMessage({ commit, rootState, state, dispatch });
      const newState = action.doStateTransition();
      action.setNewState(newState);
      action.doActionMutation(newState.transitionType);
    },

    addUserMessage({ commit, rootState, state, dispatch }, text) {
      const action = new AddUserMessage({ commit, rootState, state, dispatch });
      action.setUserMessage(text);
      action.doActionMutation();
    },

    addInterruptionMessage({ commit, rootState, state, dispatch }) {
      const action = new AddInterruptionMessage({
        commit,
        rootState,
        state,
        dispatch
      });
      const newState = action.doStateTransition();
      action.setNewState(newState);
      action.doActionMutation(newState.transitionType);
    },

    addSearchResultMessage(
      { commit, rootState, state, dispatch },
      searchResult
    ) {
      const action = new AddSearchResultMessage({
        commit,
        rootState,
        state,
        dispatch
      });
      action.setSearchResult(searchResult);
      const newState = action.doStateTransition();
      action.setNewState(newState);
      action.doActionMutation(newState.transitionType);
      commit("addStepIdHistory", {
        stepId: newState.stepId
      })
    }
  }
};
